<template>
  <div :class="jel_getClassObject(content)">
    <div class="container p-0 pt-1">
      <div
        v-if="isSpinnerVisible"
        id="spinner"
        class="d-flex flex-column justify-content-center align-items-center text-center"
      >
        <b-spinner :label="$t('chargement')"></b-spinner>
      </div>
      <div class="row">
        <div class="col text-left">
          <!-- Affichage des erreurs systèmes -->
          <div v-if="isErreurServeur">
            <MessageMel
              v-show="contentMessageMel.message"
              :content="contentMessageMel.message"
              class="mt-n1 mt-md-0 mb-1 mx-0 mx-md-auto pl-0"
            ></MessageMel>
          </div>
          <!-- Aucune erreur système (cas normal)  -->
          <div v-else>            
            <div v-if="gameActivity[selectedPeriod]">
              <Paragraphe
                :content="{
                  richText: content.titrePeriode,
                  classeCSS: 'font-weight-bold text-left pt-1 pb-2',
                }"
              ></Paragraphe>
              <div class="period-buttons">
                <button
                  v-for="key in Object.keys(gameActivity)"
                  :key="key"
                  class="btn button-period"
                  :class="{ active: selectedPeriod === key }"
                  @click="selectedPeriod = key"
                >
                  {{ $t('messageComponent.jour', { nb: key }) }}
                </button>
              </div>
              <p class="period-range">
                {{ $t('messageComponent.du') }} {{ gameActivity[selectedPeriod].startDate }} {{ $t('messageComponent.au') }}
                {{ gameActivity[selectedPeriod].endDate }}
              </p>
              <div class="game-activity-container">
                <div class="info-box">
                  <div class="gains-pertes">
                    <div class="d-flex flex-wrap label">
                      <div class="col-6 text-left">{{ content.titreGain }}</div>
                      <div class="col-6 text-right pb-1">
                        {{ gameActivity[selectedPeriod].winloss }}
                      </div>
                    </div>
                    <div class="gain-info italic col-12 text-left pb-2">{{ content.infoGain }}</div>
                  </div>
                  <div class="stats">
                    <div class="stat-item">
                      <div class="pt-1">{{ content.titreDepot }}</div>
                      <div class="pb-1 label">{{ gameActivity[selectedPeriod].deposit }}</div>
                    </div>
                    <div class="stat-item">
                      <div class="pt-1">{{ content.titreRetait }}</div>
                      <div class="pb-1 label">{{ gameActivity[selectedPeriod].withdrawn }}</div>
                    </div>
                  </div>
                  <div class="stats">
                    <div class="stat-item">
                      <div class="pt-1">{{ content.titreNbJours }}</div>
                      <div class="pb-1 label">{{ gameActivity[selectedPeriod].playdays }}</div>
                    </div>
                    <div class="stat-item">
                      <div class="stat-item-icon">
                        <div class="pt-1">{{ content.titreTempsJeux }}</div>
                        <Hyperlien
                          v-if="contentLienAideTempsJeux"
                          class="lien-aide ml-0 mt-1 mr-0 ml-1 rounded-circle cercleInfo"
                          :content="contentLienAideTempsJeux"
                        ></Hyperlien>
                      </div>
                      <div class="pb-1 label">
                        {{ gameActivity[selectedPeriod].playduration }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Paragraphe
              :content="{
                richText: content.txtLegal,
                classeCSS: 'pt-2',
              }"
              class="texte-legal"
            ></Paragraphe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import session from '@/services/api/compte/session';
import activite from '@/services/api/compte/activiteJeux';
import MessageMel from '@/components/base/MessageMel';
import MessageHelpers from '@/helpers/MessageHelpers';
import Titre from '@/components/base/Titre';
import Paragraphe from '@/components/base/Paragraphe';
import Hyperlien from '@/components/base/Hyperlien';
import store from '@/store';
import { inMgnl } from '@/helpers/AppHelpers';

export default {
  name: 'CompteActiviteJeux',
  components: {
    MessageMel,
    Paragraphe,
    Titre,
    Hyperlien,
  },
  props: { content: { type: Object, required: true }, metadata: { type: Object } },
  i18n: {
    messages: {
      fr: {
        messageComponent: {
          jour: '{nb} jours',
          du: 'Du',
          au: 'au'
        },
      },
      en: {
        messageComponent: {
          jour: '{nb} days',
          du: 'From',
          au: 'to'
        },
      },
    },
  },
  data() {
    return {
      isSpinnerVisible: true,
      message: null,
      contentMessageMel: {
        message: {},
        alert: {},
      },
      isErreurServeur: false,
      gameActivity: {},
      selectedPeriod: null,
    };
  },
  computed: {
    contentLienAideTempsJeux() {
      if (!this.content.libAideTempsJeux) {
        return null;
      }
      return {
        texte: this.content.libAideTempsJeux,
        type: 'aide text-decoration-none',
        idQuestion: this.content.idQuestionTempsJeux,
        lien: {
          field: 'aide',
          idAide: this.content.idQuestionTempsJeux,
        },
      };
    },
  },

  async mounted() {
    // Afficher le spinner au chargement de la page sauf dans Magnolia
    if (inMgnl) {
      this.isSpinnerVisible = false;
    }
    this.selectedPeriod = this.content.periodeSelection;
    const uuid = sessionStorage.getItem('lq_client_uuid');
    await this.getMyGamesActivities(uuid);
  },
  methods: {

    async getMyGamesActivities(uuid) {
      activite
        .getGamesActivities(uuid)
        .then((response) => {
          this.gameActivity = response;
          this.isErreurServeur = false;
          this.isSpinnerVisible = false;
        })
        .catch((error) => {
          console.error('Erreur de récupération des données!', error);
          this.isErreurServeur = true;
          this.isSpinnerVisible = false;
          this.recupererMessage('MSG01', 'message');
        });
    },

    recupererMessage(codeMessage, contentMessage) {
      MessageHelpers.obtenirMessage(codeMessage, this.$root)
        .then((msgResp) => {
          this.contentMessageMel[contentMessage] = {
            titre: msgResp.msgTitre,
            message: msgResp.msgDetail,
            msgType: msgResp.msgType,
          };
        })
        .catch((error) => {
          console.error('Erreur de récupération du message!', error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.compteClair button.btn.btn-primaire,
.compteClair button.btn.btn-primaire:disabled {
  color: $couleur-secondaire;
}

.texte-legal {
  font-size: 13px;
  line-height: 17px;
  color: $couleur-bleu-fonce-lq;
}

/* Classe bootstrap d-inline-block remplacée par ceci car le !important ajouté par bootstrap entre en conflit avec le v-show */
.mel-erreur,
.mel-succes,
.mel-avertissement,
.mel-info {
  display: inline-block;
  color: $couleur-blanc;
}

.lien-retour:hover {
  text-decoration: none;
}

.icone-fleche {
  margin-right: 4px;
}

.absolute-bottom {
  position: absolute;
  bottom: 0;
}

::v-deep .mel-avertissement,
.message-succes {
  display: block !important;
}

.notification-box {
  background: #e7f1ff;
  border-left: 5px solid #007bff;
  padding: 10ox;
  margin-bottom: 15px;
  border-radius: 5px;
  font-weight: bold;
}
.notification-box a {
  color: #007bff;
  font-weight: bold;
  text-decoration: none;
}

.period-buttons {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
}

@media (min-width: 992px) {
  .period-buttons {
    justify-content: flex-start;
  }
}

.period-buttons .btn {
  border: 1px solid $couleur-btn-activite-jeux;
  background: white;
  color: $couleur-text-activite-jeux;
  border-radius: 5px;
  font-weight: bold;
  padding: 10px 12px;
  margin-bottom: 0;
  white-space: nowrap;
  width: 5rem;
  text-align: center;
  font-size: 0.8rem;
  height: 2.5rem;
}

.period-buttons .btn.active {
  background: $couleur-btn-activite-jeux;
}

.period-range {
  text-align: left;
  margin-bottom: 15px;
  font-size: 14px;
}

.stat-item-icon {
  display: flex;
  justify-content: center;
}

.info-box {
  padding: 2px;
  border-radius: 0px;
}

.gain-info {
  font-size: 14px;
}

.gains-pertes {
  background: #0078dc;
  color: $couleur-blanc;
  padding: 15px 5px 0px 5px;
  text-align: center;
}

.stats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5px;
  margin-top: 5px;
}

.stat-item {
  background: #f5f2e8;
  padding: 5px;
  text-align: center;
}

.label {
  font-weight: bold;
}
</style>
